import { useEffect } from 'react';

/**
 * ForceHTTPS Component
 * Ensures the site always uses HTTPS and www subdomain
 * Redirects HTTP to HTTPS and non-www to www
 */
export const ForceHTTPS = () => {
  useEffect(() => {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    const search = window.location.search;
    
    // Check if we need to redirect
    const needsHTTPS = protocol === 'http:';
    const needsWWW = hostname === 'carolinatrophyroofs.com';
    
    // Only redirect if on production domain
    const isProduction = hostname.includes('carolinatrophyroofs.com');
    
    if (isProduction && (needsHTTPS || needsWWW)) {
      // Build the correct URL
      const correctURL = `https://www.carolinatrophyroofs.com${pathname}${search}`;
      
      // Perform the redirect
      window.location.replace(correctURL);
    }
  }, []);
  
  return null;
};

export default ForceHTTPS;
